interface AfiliadoCardProps {
  imagenId: number;
}

const EPS_IMAGES: Record<number, { src: string; alt: string }> = {
  1: { src: '/rimac.png', alt: 'RIMAC' },
  2: { src: '/pacifico.png', alt: 'PACIFICO' },
  3: { src: '/mapfre.png', alt: 'MAPFRE' },
  4: { src: '/sanitas.png', alt: 'SANITAS' },
  5: { src: '/positiva.png', alt: 'POSITIVA' },
};

export function AfiliadoCard({ imagenId }: AfiliadoCardProps): React.ReactElement {
  const eps = EPS_IMAGES[imagenId] ?? { src: '/logo-apeps.png', alt: 'APEPS' };

  return (
    <div className="group border-border bg-card shadow-medium hover:border-primary/40 hover:shadow-strong relative mx-auto flex h-36 w-36 items-center justify-center overflow-hidden rounded-full border-2 transition-all duration-500 hover:-translate-y-2 hover:scale-110 hover:border-4 md:h-40 md:w-40 lg:h-48 lg:w-48">
      <div className="from-primary/5 to-primary/10 absolute inset-0 rounded-full bg-linear-to-br opacity-0 transition-opacity duration-300 group-hover:opacity-100" />

      <img
        src={eps.src}
        alt={eps.alt}
        className="relative z-10 h-3/4 w-3/4 object-contain transition-transform duration-500 group-hover:scale-110"
      />

      <div className="from-primary/40 to-primary/50 absolute inset-0 -z-10 rounded-full bg-linear-to-r opacity-0 blur-xl transition-opacity duration-300 group-hover:opacity-20" />
    </div>
  );
}
